import { uiConstants } from '../constants';
import { FreeUserAlertEnum } from '../enums';

export default {
  ccassPage: ccassPage(),
  stockPage: stockPage(),
  updater: updater(),
  floatTutorial: floatTutorial(),
  freeUserAlert: freeUserAlert(),
};

function ccassPage() {
  return {
    dateChanged,
    compareDateChanged,
    stockCodeChanged,
    stockNameChanged,
    participantIDChanged,
    participantNameChanged,
  };

  function dateChanged(date) {
    return {
      type: uiConstants.PAGE_CCASS_DATE_CHANGED,
      date,
    };
  }

  function compareDateChanged(date?: Date) {
    return {
      type: uiConstants.PAGE_CCASS_COMPARE_DATE_CHANGED,
      date,
    };
  }

  function stockCodeChanged(stockCode) {
    return {
      type: uiConstants.PAGE_CCASS_STOCKCODE_CHANGED,
      stockCode,
    };
  }

  function stockNameChanged(stockName) {
    return {
      type: uiConstants.PAGE_CCASS_STOCKNAME_CHANGED,
      stockName,
    };
  }

  function participantIDChanged(participantID) {
    return {
      type: uiConstants.PAGE_CCASS_PARTICIPANTID_CHANGED,
      participantID,
    };
  }

  function participantNameChanged(participantName) {
    return {
      type: uiConstants.PAGE_CCASS_PARTICIPANTNAME_CHANGED,
      participantName,
    };
  }
}

function stockPage() {
  return {
    stockCodeChanged,
  };

  function stockCodeChanged(stockCode) {
    return {
      type: uiConstants.PAGE_STOCK_STOCKCODE_CHANGED,
      stockCode,
    };
  }
}

function freeUserAlert() {
  return {
    setFreeUserAlert,
  };

  function setFreeUserAlert(key: FreeUserAlertEnum, value: boolean) {
    return {
      type: uiConstants.SET_FREEUSER_ALERT,
      key,
      value,
    };
  }
}

function updater() {
  return {
    forceUpdate,
  };

  function forceUpdate() {
    return {
      type: uiConstants.FORCE_CLIENT_UPGRADE,
    };
  }
}

function floatTutorial() {
  return { showTutorial, hideTutorial, showQuestionMarks, hideQuestionMarks };

  function showTutorial(tutorialId: number) {
    return {
      type: uiConstants.SET_FLOAT_TUTORIAL_ID,
      tutorialId,
    };
  }

  function hideTutorial() {
    return {
      type: uiConstants.SET_FLOAT_TUTORIAL_ID,
      tutorialId: null,
    };
  }

  function showQuestionMarks() {
    return {
      type: uiConstants.SET_QUESTION_MARK_VISIBLE,
      showQuestionMarks: true,
    };
  }

  function hideQuestionMarks() {
    return {
      type: uiConstants.SET_QUESTION_MARK_VISIBLE,
      showQuestionMarks: false,
    };
  }
}
